'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('../_base');

var _base2 = _interopRequireDefault(_base);

var _ = require('../../../../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeckoTableCellDropdown = function (_GeckoTableCellBase) {
	_inherits(GeckoTableCellDropdown, _GeckoTableCellBase);

	function GeckoTableCellDropdown() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, GeckoTableCellDropdown);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GeckoTableCellDropdown.__proto__ || Object.getPrototypeOf(GeckoTableCellDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.tether = {
			target: _this.renderId(),
			class: 'gecko-table-cell-dropdown'
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(GeckoTableCellDropdown, [{
		key: 'renderId',
		value: function renderId() {
			if (!this.dropdownId) this.dropdownId = _.GECKO_UTILS.generateUniqueId();
			return 'gecko-table-cell-' + this.dropdownId;
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: this.renderId(), onClick: function onClick(event) {
						return event.stopPropagation();
					} },
				_react2.default.createElement(_.GeckoDropdown, {
					preset: _.GECKO_CONSTS.BTN_PRESET_ACTIONS_COMPACT,
					items: this.props.col.items,
					bind: this.props.row,
					tether: this.tether,
					index: this.props.index })
			);
		}
	}]);

	return GeckoTableCellDropdown;
}(_base2.default);

exports.default = GeckoTableCellDropdown;